import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import './style.scss';

const PopupLayout = ({ children = null, isShowwing = false, showingCallback = null, showCloseButton = true }) => {

    const closeModal = (event) => {
        if(event.target.getAttribute('class') && event.target.getAttribute('class').includes('mfp')){
            showingCallback && showingCallback(event, false);
        }
    }
    useEffect(() => {
        if(isShowwing && showCloseButton && document.querySelector('.mfp-content > div')){
            const btnClose = document.createElement('button');
            btnClose.setAttribute('title', 'Close (Esc)');
            btnClose.setAttribute('type', 'button');
            btnClose.setAttribute('class', 'mfp-close');
            btnClose.setAttribute('onclick', 'javascript:document.getElementById("btnCloseModal").click()');
            btnClose.innerHTML = '×';
            document.querySelector('.mfp-content > div').appendChild(btnClose);
        }
    }, [isShowwing]);

    return (
        <>
        {isShowwing
            &&
            <>
            <div className="mfp-bg mfp-ready"></div>
            <div className="mfp-wrap mfp-close-btn-in mfp-auto-cursor mfp-ready" onClick={(event) => closeModal(event)}>
                <div className="mfp-container mfp-s-ready mfp-inline-holder">
                    <div className="mfp-content">
                        {children}
                    </div>
                    <div className="mfp-preloader">Loading...</div>
                    <button style={{ display: 'none' }} onClick={(event) => closeModal(event)} type="button" id="btnCloseModal"></button>
                </div>
            </div>
            </>
        }
        </>
    )
};

PopupLayout.propTypes = {
    children: PropTypes.node, 
    isShowwing: PropTypes.bool, 
    showingCallback: PropTypes.func, 
    showCloseButton: PropTypes.bool
};
export default PopupLayout;
